export const ExplorerSwitcher = {
  extends: ['Grid', 'Navbar'],
  round: 'radiusPill',
  fontSize: 'Z',
  templateColumns: 'repeat(11, 1fr)',
  align: 'center center',
  onRender: (el) => el.update(),
  childProps: {
    textAlign: 'center',
    isActive: (el, s) => el.key === s.activeContent,
    onClick: (ev, el, s) => {
      const activeContent = el.key
      // el.call('setSidebarContent', activeContent)
      el.setWindow('explorer', 'explorer:' + activeContent)
    },
    theme: null
  },
  theme: null,
  children: [
    {
      icon: 'sf components',
      title: (el) => el.call('polyglot', 'editor.panel.artboards'),
      key: 'ARTBOARD_TYPES'
    },
    {
      icon: 'fnOutline',
      title: (el) => el.call('polyglot', 'editor.panel.functions'),
      key: 'FUNCTION_TYPES'
    },
    {
      icon: 'sf document',
      title: (el) => el.call('polyglot', 'editor.panel.state'),
      key: 'STATE_TYPES'
    },
    {
      icon: 'sf assets',
      title: (el) => el.call('polyglot', 'editor.panel.assets'),
      key: 'ASSETS_TYPES'
    },
    {
      icon: 'sf pallete',
      title: (el) => el.call('polyglot', 'editor.panel.colors'),
      key: 'COLOR_TYPES'
    },
    {
      icon: 'sf responsive',
      title: (el) => el.call('polyglot', 'editor.panel.responsive'),
      key: 'RESPONSIVE_TYPES'
    },
    {
      icon: 'fontFace',
      title: (el) => el.call('polyglot', 'editor.panel.typography'),
      key: 'TYPOGRAPHY_TYPES'
    },
    {
      icon: 'spaceOutlineColored',
      title: (el) => el.call('polyglot', 'editor.panel.spacing'),
      key: 'SPACING_TYPES'
    },
    {
      icon: 'iconsOutlineColored',
      title: (el) => el.call('polyglot', 'editor.panel.icons'),
      key: 'ICON_TYPES'
    },
    {
      icon: 'animationsAlt',
      title: (el) => el.call('polyglot', 'editor.panel.animation'),
      key: 'TRANSITION_TYPES'
    },
    {
      icon: 'fuse',
      title: (el) => el.call('polyglot', 'editor.panel.integrations'),
      key: 'INTEGRATIONS_TYPES'
    }
  ],
  gap: 'V',
  childExtends: {
    extends: ['NavbarButton', 'NavbarTooltipParent'],
    state: null,
    round: 'radiusPill',
    padding: 'Z -',
    width: 'initial',
    aspectRatio: 'unset'
  },
  NavbarTooltip: {
    ignoreChildExtends: true,
    ignoreChildProps: true
  }
}
